import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { InitService } from "src/app/init.service";
import { SITE_ID } from "src/app/tokens";

@Component({
	templateUrl: './impressum.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImpressumComponent implements OnInit {

	impressum: string = '';

	ngOnInit(): void {
		this.cdr.detectChanges();
	}

	constructor(
		private cdr: ChangeDetectorRef,
		private initService: InitService,
		@Inject(SITE_ID) public siteId: number
	) {
		switch(siteId) {
			case 1: this.impressum = this.initService.microData['impressumcivis']; break;
			case 2: this.impressum = this.initService.microData['impressumborsod']; break;
			case 3: this.impressum = this.initService.microData['impressumszabolcs']; break;
		}
		this.cdr.detach();
	}

}